<template>
	<div>
		<h1>Interventions</h1>

		<i
			>Interventions for each group with sufficient detail to allow replication,
			including how and when they will be administered.</i
		>
		<i
			>Criteria for discontinuing or modifying allocated interventions for a
			given trial participant (eg, drug dose change in response to harms,
			participant request, or improving/worsening disease)</i
		>
		<i
			>Strategies to improve adherence to intervention protocols, and any
			procedures for monitoring adherence (eg, drug tablet return, laboratory
			tests).</i
		>
		<i
			>Relevant concomitant care and interventions that are permitted or
			prohibited during the trial.</i
		>

		<InputTableCustom
			question="What are the intervention arms?"
			:columns="interventionColumns"
			v-model="$tera.project.TrialWizard.interventions"
			bookmark="intervetn-arms"
		/>

		<InputTableCustom
			question="What are the control arms?"
			:columns="controlColumns"
			v-model="$tera.project.TrialWizard.control"
			bookmark="control-arms"
		/>

		<InputSelectMulti
			question="Under what conditions will treatment be discontinued?"
			:options="discontinuedOptions"
			v-model="$tera.project.TrialWizard.discontinued"
			bookmark="conditions-discontinued"
		/>

		<InputSelectMulti
			question="Adherence to intervention protocols were maintained by..."
			:options="adherenceMaintainedOptions"
			v-model="$tera.project.TrialWizard.adherenceMaintained"
			bookmark="protocols"
		/>

		<InputSelectMulti
			question="Adherence was monitored by..."
			:options="adherenceMonitoredOptions"
			v-model="$tera.project.TrialWizard.adherenceMonitored"
			bookmark="adherence-moniteredby"
		/>

		<InputTextSingleLine
			question="What treatment or instructions will be given to all groups?"
			placeholder="e.g. Painkillers"
			v-model="$tera.project.TrialWizard.allInstructions"
			bookmark="treatments-groups"
		/>

		<InputTextSingleLine
			question="What interventions were not allowed?"
			placeholder="e.g. Other antibiotics"
			v-model="$tera.project.TrialWizard.prohibitedInterventions"
			bookmark="interventions-notallowed"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputInterventions from "./OutputInterventions.vue";

export default {
	data() {
		return {
			outputComponent: OutputInterventions,
			interventionColumns: [
				{
					name: "name",
					label: "What word/phrase describes this group?",
					placeholder: "e.g. antibiotic"
				},
				{
					name: "materials",
					label: "What materials will be given to this group?",
					placeholder: "e.g. 125mg of Augmentin"
				},
				{
					name: "instructions",
					label: "What instructions will be given to this group?",
					placeholder: "e.g. wear a mask when outside of home"
				}
			],
			controlColumns: [
				{
					name: "name",
					label: "What word/phrase describes this group?",
					placeholder: "e.g. placebo"
				},
				{
					name: "materials",
					label: "What materials will be given to this group?",
					placeholder: "e.g. a pill of identical size and shape to intervention"
				},
				{
					name: "instructions",
					label: "What instructions will be given to this group?",
					placeholder: "e.g. wear a mask when outside of home"
				}
			],
			discontinuedOptions: [
				{ label: "adverse reaction" },
				{ label: "participant request" },
				{ label: "improving disease" },
				{ label: "worsening disease" }
			],
			adherenceMaintainedOptions: [
				{ label: "nurses" },
				{ label: "research assistants" },
				{ label: "researchers" },
				{ label: "physicians" }
			],
			adherenceMonitoredOptions: [
				{ label: "counting drug tablets not used" },
				{ label: "laboratory tests" }
			]
		};
	}
};
</script>
